import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Swal from "sweetalert2";

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role?.toLowerCase()?.replace("_", " ");

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ ALWAYS CALL HOOKS FIRST
  useEffect(() => {
    if (!token) return;

    const restrictedRoutes = ["/create-job", "/users"];

    const isRestricted = restrictedRoutes.some((route) =>
      location.pathname.startsWith(route)
    );

    if (role === "staff" && isRestricted) {
      Swal.fire({
        icon: "warning",
        title: "Access Restricted",
        text: "You are not authorized to access this page.",
        confirmButtonColor: "#2563eb",
      }).then(() => {
        navigate("/dashboard", { replace: true });
      });
    }
  }, [location.pathname, role, navigate, token]);

  // ❌ AFTER hooks → safe return
  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default ProtectedRoute;